<ng-container *ngIf="!loading">
    <div class="grid">
        <div class="col-12 md:col-12 lg:col-12">
          <p-panel header={{vigenciaEmployee.funcionalidadControl}}>
            <form class="form-horizontal" #formVigencia="ngForm" (ngSubmit)="formVigencia.valid && updateValidityEmployee()" novalidate>
              
              <div style="display: flex; align-items: center; gap: 10px; flex-wrap: nowrap;">
                <span style="font-weight: bold;">{{ 'VIGENCIADEDATOS.LBL_EDITARVIGENCIA' | translate }}</span>     
              </div>
              
              <!-- Fila con los 3 campos principales -->
              <div class="grid form-group">

                <!-- Codigo -->
                <div class="col-12 md:col-3 lg:col-3">
                  <div class="div-form">
                    <label for="codigo">*{{ 'VIGENCIADEDATOS.LBL_CODIGO' | translate }}</label>
                    <label class="falso-combo-texto">{{ vigenciaEmployee.codigoFuncionalidadControl }}</label>
                  </div>
                </div>

                <!-- Paso flujo -->
                <div class="col-12 md:col-3 lg:col-3">
                  <div class="div-form">
                    <label for="pasoFlujo">*{{ 'VIGENCIADEDATOS.LBL_CONTROL' | translate }}</label>
                    <label class="falso-combo-texto">{{ vigenciaEmployee.funcionalidadControl }}</label>
                  </div>
                </div>
      
                <!-- Tipo vigencia -->
                <div class="col-12 md:col-3 lg:col-3">
                  <div class="div-form">
                    <label for="tipoVigencia">*{{ "VIGENCIADEDATOS.LBL_TIPOVIGENCIA" | translate }}</label>                 
                    <p-dropdown 
                      id="tipoVigencia"
                      name="tipoVigencia"
                      [options]="listTypeValidity"
                      [(ngModel)]="vigenciaEmployee.idTipoVigencia"
                      optionLabel="nombre"
                      optionValue="idLista"
                      placeholder="Seleccione un tipo"
                      required
                      #tipoVigencia="ngModel"
                    >
                  </p-dropdown>
                    <div class="p-message p-messages-error p-corner-all"
                        *ngIf="formVigencia.submitted && !tipoVigencia.valid">
                        {{ "VIGENCIADEDATOS.LBL_TIPOVIGENCIA" | translate }} {{"LBL_REQUERIDO" | translate}}
                    </div>
                  </div>
                </div>
      
                <!-- Duración -->
                <div class="col-12 md:col-3 lg:col-3" *ngIf="shouldHideDuration()">
                  <div class="div-form">
                    <label for="duracion">*{{ "VIGENCIADEDATOS.LBL_VIGENCIA" | translate }}</label>
                    <div>
                      <input type="number" pInputText class="form-control" id="duracion" name="duracion"
                             [(ngModel)]="vigenciaEmployee.duracionVigencia" required
                             (keypress)="limitToThreeDigits($event)" #duracion="ngModel"/>
                      <div class="p-message p-messages-error p-corner-all"
                          *ngIf="formVigencia.submitted && duracion && duracion.errors?.required">
                          {{ "VIGENCIADEDATOS.LBL_VIGENCIA" | translate }} {{"LBL_REQUERIDO" | translate}}
                      </div>
                      <div class="p-message p-messages-error p-corner-all"
                          *ngIf="formVigencia.submitted && duracion && vigenciaEmployee.duracionVigencia !== null && vigenciaEmployee.duracionVigencia <= 0">
                           {{ 'VIGENCIADEDATOS.MSG_DEBESERMAYOR' | translate }}
                      </div>
                      <div class="p-message p-messages-error p-corner-all"
                          *ngIf="formVigencia.submitted && duracion && vigenciaEmployee.duracionVigencia > maxDuracion">
                           {{ ('VIGENCIADEDATOS.MSG_MAXDIGITOS' | translate) + ' ' + longitudMaximaDuracion + ' ' + ('VIGENCIADEDATOS.DIGITOS' | translate) }}
                      </div>
                    </div>              
                  </div>
                </div>   
              </div>
              <!-- Botones -->
              <div class="grid form-footer-buttons">
                <div class="form-group col-12">
                    <a (click)="(formVigencia.dirty === true) ? displayDialog=true : goBack()" class="cancelar">{{ 'BTN_CANCELAR' | translate }}</a>
                    <button type="submit" pButton icon="fa fa-plus" label="{{ 'BTN_GUARDAR' | translate }}" (keydown.enter)="submit.click()"
                            #submit></button>
                </div>
              </div>
            </form>
          </p-panel>
        </div>
    </div>
  </ng-container>
  <app-loading *ngIf="loading"></app-loading>
  <p-dialog header="{{ 'LBL_CONFIRMACION' | translate }}"
            [(visible)]="displayDialog"
            [responsive]="true"
            [modal]="true">
      <p>{{ 'VIGENCIADEDATOS.MSG_CONFIRMAGUARDAR' | translate }}</p>
      <p-footer>
          <div class="ui-dialog-buttonpane ui-widget-content ui-helper-clearfix">
              <button type="button" pButton icon="fa fa-close" (click)="displayDialog=false" label="{{ 'BTN_NO' | translate }}"></button>
              <button type="button" pButton icon="fa fa-check" (click)="goBack()" label="{{ 'BTN_SI' | translate }}"></button>
          </div>
      </p-footer>
  </p-dialog>
  
  